import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSession } from '../../../lib/session';
import { usePageTitle } from '../../../lib/hooks';
import { ConfigPage } from '../../../features/admin/config/ConfigPage';

function AdminConfigRoute() {
  usePageTitle('System Configuration');
  return <ConfigPage />;
}

export const Route = createFileRoute('/_auth/admin/config')({
  beforeLoad: ({ location }) => {
    const session = getSession();
    const isAllowed =
      session?.user.type === 'group_admin' ||
      session?.user.type === 'company_admin' ||
      session?.permissions.includes('admin.config.read');

    if (!isAllowed) {
      throw redirect({
        to: '/',
        search: { callbackUrl: location.href },
      });
    }
  },
  component: AdminConfigRoute,
});
